import { render } from "./ListeVentePage.vue?vue&type=template&id=eb0fc802&ts=true"
import script from "./ListeVentePage.vue?vue&type=script&lang=ts"
export * from "./ListeVentePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__